"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLogo = void 0;
const react_1 = __importStar(require("react"));
const ThemeButton_1 = __importDefault(require("../interactions/ThemeButton"));
const styled_components_1 = __importDefault(require("styled-components"));
const Nav_1 = require("../navigation/Nav");
const externalLoginButton_1 = __importDefault(require("../interactions/externalLoginButton"));
const material_1 = require("@mui/material");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const IconLogo_1 = __importDefault(require("@/assets/icons/IconLogo"));
const react_router_dom_1 = require("react-router-dom");
const Header = ({ changeTheme, isDarkTheme }) => {
    const [width, setWidth] = (0, react_1.useState)(window.innerWidth);
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const handleResize = () => {
        setWidth(window.innerWidth);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledNotification, null,
            react_1.default.createElement(origyn_art_ui_1.Flex, { align: 'center', gap: 8 },
                react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "25", height: "24", viewBox: "0 0 25 24", fill: "none" },
                    react_1.default.createElement("rect", { x: "0.5", width: "24", height: "24", rx: "12", fill: "#FB7474" }),
                    react_1.default.createElement("path", { d: "M9.14575 7.81436C10.2614 5.88205 10.8192 4.9159 11.5554 4.60644C12.1435 4.35922 12.8064 4.35922 13.3945 4.60644C14.1307 4.9159 14.6885 5.88205 15.8041 7.81436L18.5076 12.497C19.6232 14.4293 20.1811 15.3955 20.081 16.1878C20.001 16.8207 19.6696 17.3948 19.1614 17.7805C18.5253 18.2633 17.4097 18.2633 15.1785 18.2633H9.7714C7.54016 18.2633 6.42455 18.2633 5.78845 17.7805C5.28029 17.3948 4.94884 16.8207 4.86889 16.1878C4.7688 15.3955 5.3266 14.4293 6.44222 12.497L9.14575 7.81436Z", fill: "white" }),
                    react_1.default.createElement("rect", { x: "11.7134", y: "8.13806", width: "1.52288", height: "5.61292", rx: "0.761442", fill: "#FB7474" }),
                    react_1.default.createElement("rect", { x: "11.7134", y: "14.8389", width: "1.52288", height: "1.52288", rx: "0.761442", fill: "#FB7474" })),
                react_1.default.createElement("p", null, "You\u2019re currently on the old dashboard. Please switch to the new dashboard for all features."),
                react_1.default.createElement(origyn_art_ui_1.Button, { to: "https://dashboard.origyn.com/", as: react_router_dom_1.Link, size: "small" }, "Go to new dashboard"))),
        react_1.default.createElement(StyledHeader, null,
            react_1.default.createElement(exports.StyledLogo, null,
                react_1.default.createElement(IconLogo_1.default, null),
                "OGY Dashboard"),
            width >= 960 ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Nav_1.Nav, null),
                react_1.default.createElement(material_1.Box, { sx: {
                        display: 'grid',
                        gap: '15px',
                        gridTemplateColumns: '1fr 1fr',
                        alignItems: 'center',
                        width: 'min-content',
                    } },
                    react_1.default.createElement(ThemeButton_1.default, { isDarkTheme: isDarkTheme, setDarktheme: changeTheme }),
                    react_1.default.createElement(externalLoginButton_1.default, null)))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 12, align: 'center' },
                    react_1.default.createElement(externalLoginButton_1.default, null),
                    react_1.default.createElement(Nav_1.MobileNav, { setDarktheme: changeTheme, theme: isDarkTheme })))))));
};
exports.StyledLogo = styled_components_1.default.div `
  display: flex;
  align-items: center;
    white-space: nowrap;
  margin: 0 16px;
  font-weight: 600;
  font-size: 24px;
  line-height: 1;
  gap: 3px;

  svg {
    width: 40px!important;
    flex-shrink: 0;
  }

  ${({ theme }) => theme.media.sm} {
    font-size: 18px;
  }
`;
const StyledNotification = styled_components_1.default.div `
  height: 48px;
  width: 100%;
  position: sticky;
  top: 0;
  background: #222526;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 1;
`;
const StyledHeader = styled_components_1.default.div `
  position: sticky;
  top: 48px;
  background: ${({ theme }) => theme.colors.NAVIGATION_BACKGROUND};
  z-index: 1;
  display: flex;
  height: 84px;
  align-items: center;
  gap: 54px;
  padding-right: 24px;
  justify-content: space-between;

  ${({ theme }) => theme.media.sm} {
    gap: 12px;
    padding-right: 0;
    align-items: center;
    padding: 0 12px 0 0;
  }
`;
exports.default = Header;
